import request from '@/utils/http.js'

export function addArticle(data) {
    return request({
        url: '/article/admin/add',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function getArticleList(data) {
    return request({
        url: '/article/list',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function getArticleDetailList(data) {
    return request({
        url: '/article/detailList',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function updataArticle(data) {
    return request({
        url: '/article/admin/update',
        headers: {
            isToken: true
        },
        method: 'post',
        data: data
    })
}
export function delArticle(data) {
    return request({
        url: '/article/admin/del',
        headers: {
            isToken: true
        },
        method: 'delete',
        data:data
    })
}
export function getArticle(query) {
    return request({
        url: '/article/get',
        method: 'get',
        params: query
    })
}
